(function($) {


  // const $slider = $('.cb-sublist'); 
  // const $items = $slider.find('li.flex'); 
  // const parentWidth = $slider.parent().width();
 
  // let totalWidth = 0;
  // $items.each(function () {
  //   totalWidth += $(this).outerWidth(true); 
  //   console.log($(this).outerWidth(true))
  // });


  // if (totalWidth > parentWidth) {
  //   $slider.flickity({
  //     cellAlign: 'left',
  //     contain: true,
  //     prevNextButtons: true,
  //     pageDots: false
  //   });
  // }
    $(document).ready(function() {

         $('#cb-engraving').on('change', function () {
            const selectedFont = $(this).val();
            const $preview = $('#cb-engraving-text-preview');
        
            
            $preview.removeClass(function (index, className) {
              return (className.match(/(^|\s)cb-\S+/g) || []).join(' ');
            });
        
       
            if (selectedFont) {
              $preview.addClass('cb-' + selectedFont);
            }
          });
        
          $('#cb-engraving-text').on('input', function () {
            const text = $(this).val();
            $('#cb-engraving-text-preview').text(text);
          });

      $('#cb-gift-wrapping').change(function () {
        let option_handle = $(this).data('option_handle');
        if ($(this).is(':checked')) {
          $('variant-selects fieldset[data-option-slug="' + option_handle + '"] li:nth-child(2) magnet-element label').click();
        } else {
          $('variant-selects fieldset[data-option-slug="' + option_handle + '"] li:nth-child(1) magnet-element label').click();
        }
      });

      $('.sample-switcher input').on('click', function() {
     
       const parentContainer = $(this).parents('.switcher-container').siblings('.cb-engraving-option');
       let option_handle = $(this).data('option_handle');
          
       if ($(this).is(':checked')) {
    
         parentContainer.slideDown('fast');
         $('variant-selects fieldset[data-option-slug="' + option_handle + '"] li:nth-child(2) magnet-element label').click();
         let form_id = $('#cb-engraving').data('form');
         $('#cb-engraving').attr('form', form_id);
         $('#cb-engraving-text').attr('form', form_id);
  
       } else {
  
         parentContainer.slideUp('fast');
         $('variant-selects fieldset[data-option-slug="' + option_handle + '"] li:nth-child(1) magnet-element label').click();
         $('#cb-engraving').attr('form', '');
         $('#cb-engraving-text').attr('form', '');

     }
   });

    });
})(jQuery);